// extracted by mini-css-extract-plugin
export var pickerModal = "_ic-0";
export var xButton = "_ic-1";